import { render, staticRenderFns } from "./Savingthrows.vue?vue&type=template&id=0a5bff84&scoped=true&"
import script from "./Savingthrows.vue?vue&type=script&lang=js&"
export * from "./Savingthrows.vue?vue&type=script&lang=js&"
import style0 from "./Savingthrows.vue?vue&type=style&index=0&id=0a5bff84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5bff84",
  null
  
)

export default component.exports